
export function getDomainFromUrl(url) {
    try {
        const u = new URL(url);
        return `${u.protocol}//${u.hostname}`;
    } catch (e) {
        return url;
    }
}

export function urlize(urlStub) {
    let url = ko.unwrap(urlStub);
    let prefixes = ['http://', 'https://'];
    if (!prefixes.some(prefix => url.substr(0, prefix.length) === prefix)) {
        url = 'https://' + url;
    }
    if (url[url.length - 1] === '/') {
        url = url.substr(0, url.length - 1);
    }
    return url;
}

/**
 * 
 * @param {string} domain
 * @param {string} url
 */
export function addDomainIfNeeded(domain, url) {
    if (url == null) url = '';
    if (domain == null) domain = '';

    if (url.startsWith('//')) {
        return url;
    }

    const sanitizedDomain = stripLastSlash(domain);

    if (url.startsWith('/')) {
        return sanitizedDomain + url;
    }

    if (url.startsWith('http:') || url.startsWith('https:')) {
        return url;
    }

    return sanitizedDomain + '/' + url;
}

export function replaceAll(str, search, replacement) {
    if (!str) return str;

    return str.split(search).join(replacement);
}

function stripLastSlash(url) {
    if (url[url.length - 1] === '/') {
        return url.substr(0, url.length - 1);
    }
    return url;
}

export function createDefaultRulesDescriptor() {
    return {
        condOp: 'and',
        rules: []
    }
}
